/**
 * Shared Hierarchical Facet Helper
 * Used for both Color and Material facets
 */
class HierarchicalFacetHelper {
  constructor() {
    // Store states for all facet types
    this.facetStates = {
      color: {},
      material: {}
    };
  }

  /**
   * Toggle category expansion/collapse
   * @param {string} facetType - 'color' or 'material'
   * @param {string} categoryId - The category identifier
   */
  toggleCategory(facetType, categoryId) {
    const categoryHeader = document.querySelector(`.ais-${facetType}-category-header[data-category="${categoryId}"]`);
    const categoryItems = document.querySelectorAll(`[data-category-item="${categoryId}"][data-facet-type="${facetType}"]`);
    
    if (categoryHeader && categoryItems.length > 0) {
      const isCollapsed = categoryHeader.classList.contains('collapsed');
      
      if (isCollapsed) {
        // Expand - show ALL items and remember state
        categoryHeader.classList.remove('collapsed');
        this.facetStates[facetType][categoryId] = 'expanded';
        categoryItems.forEach(item => {
          item.classList.remove('hidden');
        });
      } else {
        // Collapse - hide unselected items and remember state
        categoryHeader.classList.add('collapsed');
        this.facetStates[facetType][categoryId] = 'collapsed';
        categoryItems.forEach(item => {
          const checkbox = item.querySelector('.ais-RefinementList-checkbox');
          const isSelected = checkbox && checkbox.checked;
          if (!isSelected) {
            item.classList.add('hidden');
          }
        });
      }
    }
  }

  /**
   * Setup category click handlers
   * @param {string} facetType - 'color' or 'material'
   */
  setupCategoryHandlers(facetType) {
    const categoryHeaders = document.querySelectorAll(`.ais-${facetType}-category-header`);
    
    categoryHeaders.forEach(header => {
      // Check if handler already attached
      if (!header.hasAttribute('data-click-handler')) {
        header.setAttribute('data-click-handler', 'true');
        
        header.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const categoryId = header.getAttribute('data-category');
          if (categoryId) {
            this.toggleCategory(facetType, categoryId);
          }
        });
      }
    });
  }

  /**
   * Clean up duplicate category headers
   * @param {string} facetType - 'color' or 'material'
   */
  cleanupDuplicateCategories(facetType) {
    const categoryGroups = {};
    const allCategoryHeaders = document.querySelectorAll(`.ais-${facetType}-category-header`);
    
    allCategoryHeaders.forEach(header => {
      const categoryId = header.getAttribute('data-category');
      
      if (categoryId) {
        if (!categoryGroups[categoryId]) {
          categoryGroups[categoryId] = [];
        }
        categoryGroups[categoryId].push(header);
      }
    });
    
    // For each category, keep only the first header and remove duplicates
    Object.keys(categoryGroups).forEach(categoryId => {
      const headers = categoryGroups[categoryId];
      if (headers.length > 1) {
        // Keep the first one, remove the rest
        for (let i = 1; i < headers.length; i++) {
          headers[i].remove();
        }
      }
    });
  }

  /**
   * Get the state for a specific category
   * @param {string} facetType - 'color' or 'material'
   * @param {string} categoryId - The category identifier
   */
  getCategoryState(facetType, categoryId) {
    return this.facetStates[facetType][categoryId];
  }

  /**
   * Set the state for a specific category
   * @param {string} facetType - 'color' or 'material'
   * @param {string} categoryId - The category identifier
   * @param {string} state - 'expanded' or 'collapsed'
   */
  setCategoryState(facetType, categoryId, state) {
    this.facetStates[facetType][categoryId] = state;
  }
}

// Create global instance
window.hierarchicalFacetHelper = new HierarchicalFacetHelper();